import { render } from "./MagentoTest.vue?vue&type=template&id=4d64557e"
import script from "./MagentoTest.vue?vue&type=script&lang=js"
export * from "./MagentoTest.vue?vue&type=script&lang=js"

import "./MagentoTest.vue?vue&type=style&index=0&id=4d64557e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__